import { message, Space, Spin, Table, Typography } from "antd";
import React, { useEffect, useState } from "react";
import AxiosService from "../services/APIService";
import { LocalStorageService } from "../services/LocalStorage";

const UserFiles = () => {
  const apiService = new AxiosService();
  const [files, setFiles] = useState(null);
  const userData = LocalStorageService.getItem("user");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userData) {
      fetchDashboardData({});
    }
  }, []);

  const downloadFile = (filePath, fileName) => {
    if (!filePath) {
      console.error("File path is missing");
      return;
    }

    const anchor = document.createElement("a");
    anchor.href = filePath;
    anchor.download = fileName || "downloaded_file";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const fetchDashboardData = () => {
    setLoading(true);
    apiService
      .get(`/auth/user-dashboard/${userData._id}`)
      .then((res) => {
        setFiles(res);
      })
      .catch((e) => {
        message.error(e.message || "Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "fileName",
      render: (text) => <Typography>{text}</Typography>,
    },
    {
      title: "Action",
      key: "action",
      align: "end",
      render: (data, filePath) => {
        return (
          <Space size="middle">
            <a onClick={() => downloadFile(filePath, data.fileName)}>Download</a>
          </Space>
        );
      },
    },
  ];
  return (
    <div>
      <Spin spinning={loading} size="large">
        <Table columns={columns} dataSource={files?.uploadedFiles} pagination={false} style={{ width: "50%" }} />
      </Spin>
    </div>
  );
};

export default UserFiles;
